import { render, staticRenderFns } from "./RoundedSquare.vue?vue&type=template&id=10817df8&scoped=true&"
var script = {}
import style0 from "./RoundedSquare.vue?vue&type=style&index=0&id=10817df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10817df8",
  null
  
)

export default component.exports